<template>
    <div>
        <!-- Validation -->
        <div class="input--invalid" v-if="showPauseAnswerIdRequiredValidationMessage">
            <p class="input__message" v-text="$t('PAUSE_DELIVERIES_PLEASE_CHOOSE')"></p>
        </div>

        <h2 class="pause--heading" style="text-align: center" v-if="isPauseFlow" v-text="heading"></h2>

        <p class="pause-question" v-text="$t('PAUSE_DELIVERIES_BEFORE_WE', {flowName})"></p>

        <form method="post" class="pause-reasons">
            <div class="input__radio pause-reasons--item" v-for="answer in this.surveyAnswers" v-bind:key="answer.id">
                <input
                    class="input__radio-item"
                    :id="`${subscriptionId}:${answer.id}`"
                    v-model="pauseAnswerId"
                    type="radio"
                    :name="subscriptionId"
                    :value="answer.id"/>
                <label
                    :for="`${subscriptionId}:${answer.id}`"
                    class="input__radio-label"
                    v-text="answer.label">
                </label>
            </div>
        </form>
        <button
            @click.prevent="pauseReasonSelected"
            class="btn btn--primary btn--full-width pause-next--button"
            :class="{ 'pause-next--disabled': !pauseAnswerId}"
            v-text="nextStepButtonLabel">
        </button>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import required from 'vuelidate/src/validators/required';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import CancelSubscriptionSurveyAnswers from '@/content/cancelSubcriptionSurveyAnswers.json';
import { pauseSubscription, CSPageEvents } from '@/helpers/GAHelpers';
import { capitalizeFirstLetter } from '@/helpers/StringHelpers';

export default {
    name: 'PauseReason',
    props: {
        subscriptionId: {
            required: true,
            type: Number,
        },
    },
    data() {
        return {
            errorHandler: new ErrorResponseHandler(),
            pauseAnswerId: null,
            pauseSurveyAnswer: null,
            isNextStepClicked: false,
            surveyAnswers: null,
        };
    },
    computed: {
        ...mapGetters({
            isPauseFlow: 'account/getIsPauseFlow',
        }),
        nextStepButtonLabel() {
            return this.pauseSurveyAnswer ? 'Next step' : 'Select reason';
        },
        showPauseAnswerIdRequiredValidationMessage() {
            return this.isNextStepClicked && this.pauseAnswerId === null && !this.$v.pauseAnswerId.required;
        },
        flowName() {
            return this.isPauseFlow ? this.$t('PAUSE_STEP') : this.$t('CANCEL_STEP');
        },
        heading() {
            return capitalizeFirstLetter(this.flowName);
        },
    },
    mounted() {
        this.$scrollTo('.main');
        this.surveyAnswers = this.shuffleReasons(CancelSubscriptionSurveyAnswers.items);
    },
    validations: {
        pauseAnswerId: {
            required,
        },
    },
    watch: {
        pauseAnswerId(answerId) {
            this.pauseSurveyAnswer = this.surveyAnswers.find(answer => answer.id === answerId);
        },
    },
    methods: {
        pauseReasonSelected() {
            let stepAttempt = this.pauseSurveyAnswer?.nextSteps[0];
            let pauseReason = this.pauseSurveyAnswer?.label;
            process.env.VUE_APP_ENABLE_TRACKING === 'true' && pauseSubscription(stepAttempt, pauseReason);
            CSPageEvents(`reason-selected-${this.pauseAnswerId}`);
            this.$emit('input', this.pauseSurveyAnswer);
            this.$scrollTo('.main');
        },
        shuffleReasons(arr) {
            let currentIndex = arr.length;
            let randomIndex;
            while (currentIndex !== 0) {
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex--;
                [arr[currentIndex], arr[randomIndex]] = [arr[randomIndex], arr[currentIndex]];
            }
            return arr;
        },
    },
};
</script>

<style lang="scss" scoped>
    .pause-reasons{
        padding-bottom: 20px;
    }
    .pause-reasons--item {
        margin: 8px 0;
    }
    .pause-next--button {
        margin-bottom: 5px;
        background: #262323;
        height: 40px;
        padding-top: 0px;
        padding-bottom: 0px;
        width: 100%;
    }
    .pause-next--disabled {
        background: #cecece;
        cursor: not-allowed;
    }
</style>
